<template>
  <div class='core'>
    <div class='layui-fluid'>
      <pub-search
        :search-type="'add'"
        :tableObj='tableObj'
        :searchConfig='searchConfig'
        exportType="1"
      >
        <template>
          <button class='layui-btn' title='新增人员' @click='addRobotOnClick()'>
            <i class='layui-icon'>&#xe624;</i>新增人员
          </button>
        </template>
      </pub-search>
      <layui-table
        ref="wxPersonManagerMainViewRef"
        table-name='YW_ROBOT_WX_PSN'
        :page-size='20'
        :page-range='6'
        :page-options='[10, 20, 50, 100]'
        :skin="'line'"
        :sort="['CREATE_TIME:DESC']"
        @table-event-edit="edit($event)"
        @table-event-check="check($event)"
        @table-event-del="$refs.wxPersonManagerMainViewRef.delRows($event.data)"
      >
        <div>
          <div checkbox='true' align='center' fixed='left' width='60'></div>
          <layui-tableconfig :config='mdTableList'></layui-tableconfig>
          <div rowspan="3" align="center" fixed="right" title="操作" width="130">
            <script type="text/html" v-pre>
              <a class=" layui-btn-xs" lay-event="check" style="cursor:pointer">查看</a>
              <a class=" layui-btn-xs" lay-event="edit">编辑</a>
              <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del">删除</a>
            </script>
          </div>
        </div>
      </layui-table>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import request from "@/network/networkconfig";


export default {
  name: 'wxPersonManage',
  data () {
    return {
      mdTableList: [
        {field: 'COMPANY_NAME', title: '公司名称', width: 300},
        {field: 'BRAND_NAME', title: '品牌名称', width: 200},
        {field: 'POST_NAME', title: '职务', width: 150},
        {field: 'PSN_NAME', title: '姓名', width: 150},
        {field: 'PSN_PHONE', title: '手机号', width: 150},
        {field: 'USER_ID', title: '企业成员帐号', width: 150},
        {field: 'CREATE_USER_NAME', title: '创建人', width: 130},
        {field: 'CREATE_TIME', title: '创建时间', width: 180},
        {field: 'MEMO', title: '备注'},
      ],
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      searchConfig: {
        basic: [
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD: 'COMPANY_NAME:2, BRAND_NAME:2, POST_NAME:2, PSN_NAME:2, USER_ID:2, PSN_PHONE:2',
            PLACEHOLDER: '请输入查询条件'
          }
        ],
        advanced: [
          {TYPE: 'input', NAME: '公司名称 :', FIELD: 'COMPANY_NAME:2', PLACEHOLDER: '请输入公司名称'},
          {TYPE: 'input', NAME: '品牌名称 :', FIELD: 'BRAND_NAME:2', PLACEHOLDER: '请输入品牌名称'},
          {TYPE: 'input', NAME: '职务名称 :', FIELD: 'POST_NAME:2', PLACEHOLDER: '请输入职务名称'},
          {TYPE: 'input', NAME: '姓名 :', FIELD: 'PSN_NAME:2', PLACEHOLDER: '请输入姓名'},
          {TYPE: 'input', NAME: '手机号 :', FIELD: 'PSN_PHONE:2', PLACEHOLDER: '请输入手机号'},
          {TYPE: 'input', NAME: '企业成员帐号 :', FIELD: 'USER_ID:2', PLACEHOLDER: '请输入企业成员帐号'},
          {TYPE: 'date', NAME: '创建时间 :', FIELD: 'CREATE_TIME:2', PLACEHOLDER: '请选择创建时间'},
        ],
        showBatch: false
      },
    }
  },
  mounted(){
    this.tableObj = this.$refs.wxPersonManagerMainViewRef;
  },
  methods: {
    addRobotOnClick() {
      this.baseComponent.smartLoadComponent('wxPersonManageForm', {tableObj: this.tableObj, formType: 'add', title: '新增人员'});
    },

    check($event){
      this.baseComponent.smartLoadComponent('wxPersonManageForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'browser', title: '查看人员'})
    },

    edit ($event){
      this.baseComponent.smartLoadComponent('wxPersonManageForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'edit', title: '编辑人员'});
    },

    saveOnClick() {
      this.dialogVisible = false

      request({
        url: '/yw/qrCodeManage/addQrCode/' + this.num,
        method: 'post',
      }).then(result => {
        if (result.result.errorMsg) {
          this.layer.openAlert(result.result.errorMsg)
        } else {
          this.layer.openSuccess('新增成功!', { targetEl: $('body')})
          this.tableObj.load();
          this.num = 1
        }
      }, null, { targetEl : $('body')})
    },

    handleChange(value) {
      this.num = value
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/repairs/wxPersonManage/index.vue